/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Event_Not_Yet_Started_TitleInputs */

const en_dialog_event_not_yet_started_title = /** @type {(inputs: Dialog_Event_Not_Yet_Started_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event pending`)
};

const ar_dialog_event_not_yet_started_title = /** @type {(inputs: Dialog_Event_Not_Yet_Started_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الحدث معلق`)
};

const de_dialog_event_not_yet_started_title = /** @type {(inputs: Dialog_Event_Not_Yet_Started_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ereignis ausstehend`)
};

const es_dialog_event_not_yet_started_title = /** @type {(inputs: Dialog_Event_Not_Yet_Started_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evento pendiente`)
};

const fr_dialog_event_not_yet_started_title = /** @type {(inputs: Dialog_Event_Not_Yet_Started_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Événement à venir`)
};

const it_dialog_event_not_yet_started_title = /** @type {(inputs: Dialog_Event_Not_Yet_Started_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evento in attesa`)
};

const ja_dialog_event_not_yet_started_title = /** @type {(inputs: Dialog_Event_Not_Yet_Started_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベント保留中`)
};

const ko_dialog_event_not_yet_started_title = /** @type {(inputs: Dialog_Event_Not_Yet_Started_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이벤트 대기 중`)
};

const pt_br_dialog_event_not_yet_started_title = /** @type {(inputs: Dialog_Event_Not_Yet_Started_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evento pendente`)
};

const ru_dialog_event_not_yet_started_title = /** @type {(inputs: Dialog_Event_Not_Yet_Started_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Событие ожидается`)
};

const th_dialog_event_not_yet_started_title = /** @type {(inputs: Dialog_Event_Not_Yet_Started_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กำลังรออีเวนต์`)
};

const tr_dialog_event_not_yet_started_title = /** @type {(inputs: Dialog_Event_Not_Yet_Started_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etkinlik beklemede`)
};

const zh_cn_dialog_event_not_yet_started_title = /** @type {(inputs: Dialog_Event_Not_Yet_Started_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`活动尚未开始`)
};

const zh_tw_dialog_event_not_yet_started_title = /** @type {(inputs: Dialog_Event_Not_Yet_Started_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`活動尚未開始`)
};

/**
* | output |
* | --- |
* | "Event pending" |
*
* @param {Dialog_Event_Not_Yet_Started_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const dialog_event_not_yet_started_title = /** @type {((inputs?: Dialog_Event_Not_Yet_Started_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Event_Not_Yet_Started_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dialog_event_not_yet_started_title(inputs)
	if (locale === "ar") return ar_dialog_event_not_yet_started_title(inputs)
	if (locale === "de") return de_dialog_event_not_yet_started_title(inputs)
	if (locale === "es") return es_dialog_event_not_yet_started_title(inputs)
	if (locale === "fr") return fr_dialog_event_not_yet_started_title(inputs)
	if (locale === "it") return it_dialog_event_not_yet_started_title(inputs)
	if (locale === "ja") return ja_dialog_event_not_yet_started_title(inputs)
	if (locale === "ko") return ko_dialog_event_not_yet_started_title(inputs)
	if (locale === "pt_br") return pt_br_dialog_event_not_yet_started_title(inputs)
	if (locale === "ru") return ru_dialog_event_not_yet_started_title(inputs)
	if (locale === "th") return th_dialog_event_not_yet_started_title(inputs)
	if (locale === "tr") return tr_dialog_event_not_yet_started_title(inputs)
	if (locale === "zh_cn") return zh_cn_dialog_event_not_yet_started_title(inputs)
	return zh_tw_dialog_event_not_yet_started_title(inputs)
});